/* eslint-disable no-prototype-builtins */
import { string } from "yup";
import * as yup from "yup";
import { forbiddenPhones, forbiddenDomains, forbiddenEmailNames, forbiddenEmails } from "./blackLists";
import { db } from "~db/db";

const contatoValidation = () => {
  return {
    nome: yup
      .string()
      .matches(/^[A-Za-zÀ-ÿ\s]{1,50}$/, "O Nome deve conter no máximo 50 letras!")
      .required("O nome é obrigatório!"),
    sobrenome: yup
      .string()
      .matches(/^[A-Za-zÀ-ÿ\s]{1,50}$/, "O sobrenome deve conter no máximo 50 caracteres e apenas letras")
      .required("O sobrenome é obrigatório!"),
    cargoId: yup.number().required("O cargo é obrigatório!"),
    email: emailValidation(),
    telefone: yup.string().test("contatos.telefone", "Telefone incompleto!", function (value) {
      if (value === undefined) {
        return this.createError({
          message: "O telefone é obrigatório!",
        });
      } else {
        if (checkForbiddenPhones(value)) {
          return this.createError({
            message: `Telefone inválido. O número ${value} não é permitido`,
          });
        } else {
          if (value.length <= 14) {
            return yup
              .string()
              .matches(/^(\(?\d{2}\)?[-\s]?)?(\d{4,5}[-\s]?\d{4})$/, {
                message: "Telefone inválido",
                excludeEmptyString: true,
              })
              .isValidSync(value);
          }
        }
      }
      return true;
    }),
    celular: yup.string().test("contatos.celular", "Celular incompleto!", function (value) {
      if (value === undefined) {
        return true;
      } else {
        if (checkForbiddenPhones(value)) {
          return this.createError({
            message: `Celular inválido. O número ${value} não é permitido`,
          });
        } else {
          if (value.length <= 14) {
            return yup
              .string()
              .matches(/^(\(?\d{2}\)?[-\s]?)?(\d{4,5}[-\s]?\d{4})$/, {
                message: "Celular inválido",
                excludeEmptyString: true,
              })
              .isValidSync(value);
          }
        }
      }
      return true;
    }),
  };
};

const enderecoValidation = () => {
  const location = window.location.pathname;

  const isCepRequired = !(/\/carteira\/prospect\/\d+/.test(location));

  return {
    cep: yup
    .string()
    .nullable()
    .required("CEP é obrigatório")
    .matches(/^\d{5}-\d{3}$/, "CEP inválido")
    .test("required-if", "O cep é obrigatório", value => !(isCepRequired && !value)),
    numero: yup
      .string()
      .required("Número é obrigatório")
      .matches(
        /^(?:\d{1,13}|[Ss]\/[Nn])$/,
        "O número deve conter no máximo 13 caracteres e ser apenas números ou s/n!"
      ),
    complemento: yup.string().max(50, "O complemento deve conter no máximo 50 caracteres!"),
    uf: yup
      .string()
      .matches(/^[A-Za-z]{1,2}$/, "O UF deve receber apenas 2 letras!")
      .required("O UF é obrigatório"),
    rua: yup
  .string()
  .max(50, "O campo deve conter no máximo 50 caracteres")
  .required("A rua é obrigatória")
  .test("endereco-bloqueado", "O endereço não pode ser igual ao do emissor", function (value) {
    const { enderecoBloqueado } = this.parent;
    return enderecoBloqueado !== true;
  }),
    bairro: yup.string().max(50, "O bairro deve ter no máximo 50 caracteres!").required("O bairro é obrigatório"),
    cidadeId: yup.number().required("A cidade é obrigatória"),
  };
};
const informacoesAdicionaisValidation = () => {
  return {
    faseObra: string().max(50, "A Fase de obra deve conter no máximo apenas 50 letras!"),

    sistemaConstrutivo: string().max(50, "O Sistema Construtivo deve conter no máximo apenas 50 letras!"),
    numeroPavimentos: yup
      .string()

      .matches(/^\d{1,13}$/, "O Números de Pavimentos deve conter no máximo 13 caracteres e ser apenas números")
      .test("is-integer", "O Números de Pavimentos deve ser um número inteiro", (value) => {
        if (!value) return true;
        return Number.isInteger(Number(value));
      }),
    quantidadeTorres: yup
      .string()
      .matches(/^\d{1,13}$/, "A Quantidade de Torres deve conter no máximo 13 caracteres e ser apenas números")
      .test("is-integer", "A Quantidade de Torres deve ser um número inteiro", (value) => {
        if (!value) return true;
        return Number.isInteger(Number(value));
      }),
    // filialId: yup.number(),
    // produtoId: yup.number(),
    volumePotencial: yup
      .string()
      .matches(/^(\d|\.){1,30}$/, "O Volume Potencial deve conter apenas números ")
      .test("is-integer", "O Volume Potencial deve conter apenas números", (value) => {
        if (!value) return true;
        return Number.isInteger(Number(value));
      }),
    negociacaoDate: string().matches(
      /^(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[0-2])[/](19|20)\d\d$/,
      "Insira uma data válida no formato dd/mm/aaaa"
    ),
  };
};


function isValidDate(value) {
  if (!value) return false;
  const regex = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
  if (!regex.test(value)) return false;

  const [day, month, year] = value.split("/").map(Number);
  const lastDayOfMonth = new Date(year, month, 0).getDate();

  if (year < 1000 || year > 9999 || month < 1 || month > 12 || day < 1 || day > lastDayOfMonth) return false;

  const birthDate = new Date(year, month - 1, day);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (birthDate >= today) return false;

  return true;
}

const informacoesGeraisValidation = () => {
  return {
    codigoSAP: string().matches(/^\d{1,10}$/, "Código SAP deve ter no máximo 10 números"),
    codigoVendedor: string().matches(/^\d{1,10}$/, "Código SAP deve ter no máximo 10 números!"),
    nomeFantasia: string()
      .max(50, "O Nome fantasia deve conter no máximo 50 letras!")
      .required("O Nome fantasia é obrigatório"),

    inscricaoEstadual: yup
      .string()
      .nullable()
      .transform((value) => value?.trim() || null)
      .test("minLength", "Deve conter no mínimo 6 caracteres", function (value) {
        if (!value) return true;
        return value.replace(/\s/g, "").length >= 6;
      })
      .test("validCharacters", "Somente letras e números são permitidos", function (value) {
        if (!value) return true;
        return /^[A-Za-zÀ-ÿ0-9 ]+$/.test(value);
      }),

    inscricaoMunicipal: yup
      .string()
      .nullable()
      .transform((value) => value?.trim() || null)
      .matches(/^[0-9]*$/, "Somente números são permitidos")
      .min(6, "Deve conter no mínimo 6 dígitos"),

    razaoSocial: string()
      .matches(/^[A-Za-zÀ-ÿ0-9\s]{1,50}$/, "A razão social deve conter no máximo 50 letras")
      .required("A razão social é obrigatório"),
    tipo: yup.number().required("O Tipo de pessoa é obrigatorio"),
    dataNascimento: yup.string().test(
      "conditionalDateValidation",
      "Data inválida",
      function (value) {
        const { tipo } = this.parent;

        if (tipo !== 1) return true;

        return isValidDate(value);
      }
    ),
    documento: string()
      .test("cnpjCpf", "CPF ou CNPJ incompleto!", function (value) {
        if (!value) {
          return false;
        }
        if (value.length === 14) {
          if (!validaCPF(value)) return this.createError({ message: "O número de CPF é inválido" });

          return string()
            .matches(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, {
              message: "CPF inválido",
              excludeEmptyString: true,
            })
            .isValidSync(value);
        } else if (value.length === 18) {
          if (!validaCNPJ(value)) return this.createError({ message: "O número de CNPJ é inválido" });

          return string()
            .matches(/^[A-Za-z0-9]{2}\.[A-Za-z0-9]{3}\.[A-Za-z0-9]{3}\/[A-Za-z0-9]{4}-\d{2}$/, {
              message: "CNPJ inválido",
              excludeEmptyString: true,
            })
            .isValidSync(value);
        }

        return false;
      })
      .required("CPF ou CNPJ é obrigatório"),
    trilhaId: yup.number().required("A trilha é obrigatória"),
    grupoSegmentoId: yup.number().required("O grupo de segmento é obrigatório"),
    segmentoId: yup.number().required("O segmento é obrigatório"),

    trilhaGlobal2: string().matches(/^[A-Za-z]{1,4}$/, "A trilha deve receber no máximo 4 letras"),
    email: emailValidation(),
    telefone: string().test("telefone", "Preencha o número de telefone!", function (value) {
      if (value === undefined) {
        return this.createError({
          message: "O telefone é obrigatório!",
        });
      } else {
        if (checkForbiddenPhones(value)) {
          return this.createError({
            message: `Telefone inválido. O número ${value} não é permitido`,
          });
        } else {
          if (value.length <= 14) {
            return yup
              .string()
              .matches(/^(\(?\d{2}\)?[-\s]?)?(\d{4,5}[-\s]?\d{4})$/, {
                message: "Telefone inválido",
                excludeEmptyString: true,
              })
              .isValidSync(value);
          }
        }
      }

      return true;
    }),
    celular: string().test("celular", "Preencha o número de celular!", function (value) {
      if (value === undefined) {
        return this.createError({
          message: "O celular é obrigatório!",
        });
      } else {
        if (checkForbiddenPhones(value)) {
          return this.createError({
            message: `Celular inválido. O número ${value} não é permitido`,
          });
        } else {
          if (value.length <= 14) {
            return yup
              .string()
              .matches(/^(\(?\d{2}\)?[-\s]?)?(\d{4,5}[-\s]?\d{4})$/, {
                message: "Celular inválido",
                excludeEmptyString: true,
              })
              .isValidSync(value);
          }
        }
      }

      return true;
    }),
    usuarioId: yup.number(),
    recebimento: string()
      .required("O Recebimento é obrigatório")
      .max(50, "O Recebimento deve conter no máximo 50 caracteres"),
      equipeVendaId: yup.mixed().nullable().test(
        "conditionalEquipeVenda",
        "Equipe de Venda é obrigatória",
        function (value) {
          const { codigoSAP } = this.parent;

           return !(((!codigoSAP || codigoSAP === "0") && !value) || (value && String(value).length > 50));

        }
      ),
      escritorioVendaId: yup.mixed().nullable().test(
        "conditionalEscritorioVendaValidation",
        "Escritório de Venda é obrigatório",
        function (value) {
          const { codigoSAP } = this.parent;

          return (
            (codigoSAP && codigoSAP !== "0") ||
            (!!value && String(value).length <= 50)
          );
        }
      ),

    classificacaoFiscal: string().nullable(),
    grupoCentralizadorId: yup.number(),
    descargaCliente: yup.boolean(),
    descargaFumaca: yup.boolean(),
    paletizado: yup.boolean(),
  };
};

function emailValidation() {
  return string().test("emailValidation", "E-mail obrigatório", async function (value) {
    const valDec = value;

    const whitelist = await db.parametros.where("slug").equals("whitelist-extensao-email").first();
    const emailBlacklist = await db.parametros.where("slug").equals("blacklist-email").first();
    const validExtensions = whitelist?.valor.split(",").map((v) => v.trim());
    const dynamicForbiddenEmails = (emailBlacklist?.valorCorrigido ?? emailBlacklist?.valor ?? "")
      .split(/[,;\n]/)
      .map((item) => item.trim().toLowerCase())
      .filter(Boolean);

    if (!valDec) return false;
    const normalizedValue = valDec.toLowerCase();
    const hasValidExtension = (validExtensions ?? []).some((ext) => normalizedValue.endsWith(ext));

    if (!hasValidExtension) {
      return this.createError({
        message: "Digite um endereço de e-mail que contenha uma das extensões: " + (validExtensions ?? []).join(", "),
      });
    }

    const splited = valDec.split("@");

    if (splited.length != 2) {
      return this.createError({
        message: "E-mail inválido",
      });
    }

    const emailName = splited[0];
    const domain = splited[1];

    const forbiddenName = Object.keys(forbiddenEmailNames).some((key) => emailName === key.toLowerCase());

    if (forbiddenName) {
      return this.createError({
        message: "E-mail inválido",
      });
    }

    const splitedDomain = domain.split(".");

    const forbiddenDomain = Object.keys(forbiddenDomains).some(
      (key) => splitedDomain.join(".").toLowerCase() === key.toLowerCase()
    );

    if (forbiddenDomain) {
      return this.createError({
        message: "Domínio inválido",
      });
    }

    const forbiddenEmail = Object.keys(forbiddenEmails).some((key) => normalizedValue === key.toLowerCase());
    const dynamicForbiddenEmail = dynamicForbiddenEmails.includes(normalizedValue);

    if (forbiddenEmail || dynamicForbiddenEmail)
      return this.createError({
        message: "Endereço de e-mail inválido",
      });

    return string().email("Digite um endereço de e-mail válido").isValidSync(normalizedValue);
  });
}

const checkForbiddenPhones = (value) => {
  let numbers = value.replace(/\([^)]*\)/g, "");
  numbers = numbers.replace(/\D/g, "");

  const forbidden = Object.keys(forbiddenPhones).some((key) => numbers.startsWith(key));

  return forbiddenPhones[numbers] !== undefined || forbidden;
};

function getFields(obj, fields) {
  const resultado = {};
  if (Array.isArray(fields)) {
    fields.forEach((campo) => {
      if (obj.hasOwnProperty(campo)) {
        resultado[campo] = obj[campo];
      } else {
        console.error(`O campo '${campo}' não existe no objeto enviado.`);
      }
    });
  }

  return resultado;
}

function validaCNPJ(cnpj) {
  if (!cnpj) return false;

  const clean = cnpj.replace(/[^\da-zA-Z]/g, "").toUpperCase();
  if (clean.length !== 14) return false;

  const base = clean.slice(0, 12);
  const dvInformado = clean.slice(12);

  const charToValue = (char) => char.charCodeAt(0) - 48;

  const calcularDV = (baseValue, pesos) => {
    let soma = 0;
    for (let i = 0; i < baseValue.length; i++) {
      soma += charToValue(baseValue[i]) * pesos[i];
    }
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  const pesosPrimeiro = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const pesosSegundo = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const primeiroDV = calcularDV(base, pesosPrimeiro);
  const segundoDV = calcularDV(base + primeiroDV, pesosSegundo);

  return dvInformado === `${primeiroDV}${segundoDV}`;
}

function validaCPF(strCpf) {
  let cpf = strCpf.replace(/\([^)]*\)/g, "");
  cpf = cpf.replace(/\D/g, "");

  let Soma;
  let Resto;
  Soma = 0;
  if (cpf == "00000000000") return false;

  for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(cpf.substring(9, 10))) return false;

  Soma = 0;
  for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(cpf.substring(10, 11))) return false;
  return true;
}

export {
  enderecoValidation,
  informacoesAdicionaisValidation,
  informacoesGeraisValidation,
  contatoValidation,
  getFields,
  validaCNPJ,
  validaCPF,
};
